import { databaseService } from '../databaseService';
import { ChecklistStructuralMutationService } from './ChecklistStructuralMutationService';

/** Retira o modelo do catálogo sem apagar seus checklists ou os arquivos históricos. */
export class ChecklistTemplateCleanupHelper {
  async cleanupCompleteTemplate(templateId: string, empresaId: string) {
    const template = await databaseService.readItem<any>('guincho_templates_checklist', templateId);
    if (!template || template.empresa_id !== empresaId) throw new Error('template_retirement_identity_mismatch');
    const templateRetired = await new ChecklistStructuralMutationService().retireTemplate(templateId);
    if (!templateRetired) throw new Error('template_retirement_not_committed');
    return { checklistsRemoved: 0, localImagesRemoved: 0, remoteImagesRemoved: 0, recordsRemoved: 0,
      fieldsRemoved: 0, templateRemoved: false, templateRetired, totalImagesRemoved: 0 };
  }
}
